export default __webpack_public_path__ + "static/media/Img047.e55c3fb4.jpg";